import { Flex, Text } from '@chakra-ui/react';
import Button from 'common/components/button';
import { doesClaimRequirePayment } from 'common/utils/misc';
import { ApplyFormContainer, ApplyFormLayout } from 'common/layouts/apply-form';
import { InfoField } from 'common/components/info-card';
import { formatDateToHumanDate } from 'common/utils/formDateToHumanTime';
import ClaimsPaymentSummaryCard from 'components/claims/claims-payment-summary';
import ContactCard from 'components/shared/contact-card';
import ApplyContent from 'components/apply-shared/apply-content';
import ApplyTitle from 'components/apply-shared/apply-title';
import ApplyButtons from 'components/apply-shared/apply-buttons';
import { useFinalizeAClaimMutation } from 'redux/api/ciosUsersApi/ciosUsersApi';
import { toast } from 'react-toastify';
import { extractErrorMsg } from 'utils/errors';

const Step1FinalizedOptions = ({ claim, claimId, onProceedToPayment, onFinalizeClaim, onBackClick }) => {
  const requiresPayment = doesClaimRequirePayment(claim);
  const [finalizeClaim, { isLoading: finalizeClaimLoading }] = useFinalizeAClaimMutation();

  const handleFinalizeClaim = () => {
    finalizeClaim({ claimId: claimId })
      .unwrap()
      .then(() => {
        if (onFinalizeClaim) {
          onFinalizeClaim();
        }
      })
      .catch((error) => {
        const errMsg = extractErrorMsg(error, 'Finalize Failed');
        toast.error(errMsg);
      });
  };

  return (
    <div className='flex flex-col w-full h-full'>
      <ApplyTitle
        title='Finalize Claim Resolution'
        subtitle='Please confirm your move-out date and finalize the claim.'
        buttons={
          <ApplyButtons
            onBackClick={onBackClick}
            backTitle='Change Move Out Date'
            onNextClick={requiresPayment ? onProceedToPayment : handleFinalizeClaim}
            nextTitle={requiresPayment ? 'Complete Payment' : 'Finalize Claim'}
            isValid={true}
            moveOn={true}
            loading={finalizeClaimLoading}
          />
        }
      />

      <ApplyContent>
        <ApplyFormContainer>
          <ApplyFormLayout className='pb-6'>
            <Flex className='flex-col gap-2 col-span-2'>
              <Text className='font-medium text-lg col-span-2'>
                Claim Resolution Details
              </Text>
              <Text className='text-base text-gray-500'>
              By finalizing this claim, you are agreeing to the resolution. The move-out date you have chosen will be finalized and will not be able to be changed once finalized.
              </Text>  
            </Flex>
            <InfoField title='Move Out Date'>
              {formatDateToHumanDate(claim?.submission?.confirmedDate)}
            </InfoField>
            <InfoField title='Review' className='col-span-2'>
              {claim?.review?.reason}
            </InfoField>                  
          </ApplyFormLayout>
          {requiresPayment && (
              <div className='col-span-2 py-6 mb-3'>
                <ClaimsPaymentSummaryCard claim={claim} />
              </div>
            )} 
          <ContactCard className='pt-4' border={false} title='Need help with your claim?'>
            <Text className='text-base text-gray-500'>
              If you have any concerns or questions about your claim, please reach out to our support team.
            </Text>
          </ContactCard>
        </ApplyFormContainer>
      </ApplyContent>
    </div>
  );
};

export default Step1FinalizedOptions; 